import { useState, useEffect } from 'react';
import spotlightService from '../services/SpotlightService';

/**
 * Hook to fetch dynamic page content from the API
 * @param {string} slug - Page slug (e.g., 'terms-of-use', 'privacy-policy', 'about', 'contact')
 * @returns {Object} { page, loading, error }
 */
const usePageContent = (slug) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPageContent = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        console.log(`📄 usePageContent: Fetching page content for slug: "${slug}"`);
        const response = await spotlightService.getPageContent(slug);
        console.log(`📄 usePageContent: API Response for "${slug}":`, response);
        
        if (response?.success && response?.page) {
          console.log(`✅ usePageContent: Page data found for "${slug}":`, {
            page_name: response.page.page_name,
            nav_name: response.page.nav_name,
            hasHtml: !!response.page.html,
            hasBody: !!response.page.body,
            htmlLength: response.page.html?.length || 0,
            bodyLength: response.page.body?.length || 0,
          });
          setPage(response.page);
        } else {
          console.warn(`⚠️ usePageContent: No page data found for "${slug}", using fallback`);
          setError('Failed to load page content');
        }
      } catch (err) {
        console.error(`❌ usePageContent: Error fetching page content for ${slug}:`, err);
        setError(err.message || 'Failed to load page content');
      } finally {
        setLoading(false);
      }
    };

    fetchPageContent();
  }, [slug]);

  return { page, loading, error };
};

export default usePageContent;

